import { Component, Input, OnInit, SimpleChanges, OnDestroy } from "@angular/core";
import {
  GameMessageType,
  GameModalMessage,
  PrizeDetail,
} from "src/app/shared/constants/divisional.interface";
import { PRIZETYPES, GAMETYPES } from "src/app/shared/constants/constants";
import { GameService } from "src/app/shared/services/game/game.service";
import moment from "moment-mini";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: "app-prize-card",
  templateUrl: "./prize-card.component.html",
})
export class PrizeCardComponent implements OnInit, OnDestroy {
  @Input() gameId: string;
  @Input() prize: PrizeDetail;
  @Input()
  set availablePoints(value: number) {
    this._availablePoints = value;
  }
  get availablePoints(): number {
    return this._availablePoints;
  }

  @Input() userOptedIn: boolean = false;
  @Input() gameType: string = "";
  @Input() tokenLabelSingular: string = "";
  @Input() tokenLabelPlural: string = "";
  @Input() userInfo: any = null;

  public sm = "575px";
  public md = "768px";
  public imagePath: string;
  public prizeDetailPath: string = "";
  public _availablePoints: number = 0;
  public PRIZETYPES = PRIZETYPES;
  public GAMETYPES = GAMETYPES;
  public linktext: string = "";
  private currentEnvironment: string;
  private destroy$ = new Subject<void>();

  constructor(public gameService: GameService, public router: Router,) {}

  ngOnInit(): void {
    this.currentEnvironment = this.gameService.getEnvironment();
    this.imagePath = environment[this.currentEnvironment].imagePath;
    this.gameService.refreshOptInStatusOnlyObservable.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if(data) {
        if(data.prizeDetail.prizeId == this.prize.prizeId) {
          setTimeout(() => {
            this.redeemPrize(data.elementEvent);
          }, 0);
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.gameType) {
      this.linktext = this.getTitle();
    }
  }

  public prizeDetailsHandler(event: Event) {
    event.preventDefault();
    this.router.navigate(['games/prize-details', this.gameId, this.prize.prizeId, this.prize.type]);
  }
  public getTitle() {
    let title = "Details";

    if (this.gameType == GAMETYPES.EPISODIC) {
      title = "Learn more";
    }

    return title;
  }

  public isDisabled(): boolean {
    if(this.gameService.optinEnhancements && this.gameType == GAMETYPES.DIVISION && (this._availablePoints >= this.prize.burnPoints)) {
      return false;
    } else {
      return this._availablePoints < this.prize.burnPoints || !this.userOptedIn;
    }
  }

  public getImageUrl(prize: PrizeDetail, viewport: string): string {
    let id = prize.prizeId;
    if (prize.type == PRIZETYPES.B4U_OFFER && prize.imageId) {
      id = prize.imageId;
    }
    const modifiedImagePath = this.imagePath;
    return modifiedImagePath
      ? modifiedImagePath
          .replace("${product.id}", id)
          .replace("${viewport}", viewport)
      : "";
  }

  public userOptinFlow(event) {
    let message: GameModalMessage = {
      mode: GameMessageType.SHOWOPTINFROMPRIZE,
      prizeDetail: this.prize,
      gameId: this.gameId || "",
      userInfo: this.userInfo,
      elementEvent: event
    };
    this.gameService.gameModalMessage.next(message);

  }

  public redeemPrize(event=null) {
    // prevent someone from removing disabled attributes on button
    if (!this.isDisabled()) {
      if(this.gameService.optinEnhancements) {
        if((this.prize.type == PRIZETYPES.SWEEPSTAKES || this.prize.type == PRIZETYPES.VENDOR) && !this.userOptedIn) {
          //Start OptinFlow.
          this.userOptinFlow(event);
          return;
        }
      }
      // start redemption flow
      let message: GameModalMessage = {
        mode: GameMessageType.PRIZEREDEEM,
        prizeDetail: this.prize,
        gameId: this.gameId || "",
        userInfo: this.userInfo,
        elementEvent: event?.target
      };

      this.gameService.gameModalMessage.next(message);
    }
  }

  public showExpirationDate(): boolean {
    let ret: boolean = false;

    if (
      this.prize.type != PRIZETYPES.SWEEPSTAKES &&
      this.prize.expirationDate
    ) {
      ret = true;
    }

    return ret;
  }

  public expirationShortDate(): string {
    if(this.prize.type === PRIZETYPES.SWEEPSTAKES) {
      return this.gameService.shortDate(this.prize.sweepstakeDrawDate.split(" ")[0], "/", true);
    }
    return this.gameService.shortDate(this.prize.expirationDate.split(" ")[0], "/", true);
  }

  public getSRExpirationDate(): string {
    const shortDateString =  this.gameService.shortDate(this.prize.expirationDate.split(" ")[0]);
    const dateObject = moment(shortDateString, "MM/DD/YYYY").toDate();
    return moment(dateObject).format("dddd MMMM Do yyyy");
  }

  public prizeRedeemTokenLabel(points: number) {
    if (Math.abs(points) == 1) {
      return points + " " + this.tokenLabelSingular;
    } else {
      return points + " " + this.tokenLabelPlural;
    }
  }

  ngOnDestroy() {
    this.destroy$.next();  // This will trigger the unsubscription
    this.destroy$.complete();
  }
}
